const hostname = window.location.hostname;
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
const isDev = import.meta.env.MODE === 'development';

let API_BASE_URL;
let SOCKET_URL;

if (isDev) {
  if (isLocalhost) {
    API_BASE_URL = 'http://localhost:5001/api';
    SOCKET_URL = 'http://localhost:5001';
  } else {
    // LAN access — use whatever IP the page was served from
    API_BASE_URL = `http://${hostname}:5001/api`;
    SOCKET_URL = `http://${hostname}:5001`;
  }
} else {
  API_BASE_URL = import.meta.env.VITE_API_URL_PROD;
  SOCKET_URL = import.meta.env.VITE_SOCKET_URL_PROD;
}

export { API_BASE_URL, SOCKET_URL };
